import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 2A24B473-B162-4B0E-9723-6867EEA702A9
 * name folder-text
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-text.svg
 * tags
 * - Files / Folders 
 */
export const FolderTextIcon = createSvgIcon(<><path d="M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6M15,16H6V14H15V16M18,12H6V10H18V12Z" /></>, 'FolderTextIcon');
export default FolderTextIcon